import { z } from "zod";

const authHeaderSchema = z.object({
  Authorization: z
    .string()
    .refine((s) => s.length > 0, {
      message: "Token is required",
    })
    .refine((s) => s.startsWith("Bearer "), {
      message: "Token must start with 'Bearer '",
    }),
});

export type AuthHeader = z.infer<typeof authHeaderSchema>;
type AuthHeaderInput = z.input<typeof authHeaderSchema>;

const newAuthHeader = (input: AuthHeaderInput): AuthHeader => {
  const parsed = authHeaderSchema.safeParse(input);
  if (!parsed.success) {
    throw new Error("Invalid auth token");
  }
  return parsed.data;
};

export const useAuthHeader = (): AuthHeader => {
  return newAuthHeader({
    Authorization: `Bearer ${localStorage.getItem("token")}`, // TODO: Maybe we can get the token from another place.
  });
};
